import type { ConfigRepository } from '@/core/config'
import type { UseCase } from '@/core/shared'

export const getConfig: UseCase<ConfigRepository, 'getConfig'> = repository => {
  return async () => {
    return await repository.getConfig()
  }
}
